import { SaveAclRequest, Resource, Acl, EffectivePermissionAcl } from "@/services/security/types";
import Api from "@/services/api";
import { UserResourceClaims } from "@/store/authentication/types";

export async function getACL(id: string): Promise<Array<Resource>> {
    return new Promise((resolve, reject) => {
        Api.get(`/acl/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function saveACL(saveAclRequest: SaveAclRequest): Promise<Array<UserResourceClaims>> {
    return new Promise((resolve, reject) => {
        Api.post("/acl/", saveAclRequest).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserAcl(id: string, type: string = ""): Promise<Acl[]> {
    return new Promise((resolve, reject) => {
        const url = type.length === 0 ? `/acl/user/${id}` : `/acl/user/${id}/${type}`;
        Api.get(url).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserInheritedAcl(id: string): Promise<EffectivePermissionAcl[]> {
    return new Promise((resolve, reject) => {
        const url = `/acl/user/inheritedAcls/${id}`;
        Api.get(url).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserGroupAcl(id: string, type: string = ""): Promise<Acl[]> {
    return new Promise((resolve, reject) => {
        const url = type.length === 0 ? `/acl/usergroup/${id}` : `/acl/usergroup/${id}/${type}`;
        Api.get(url).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
